import { createContext } from 'react'
import { NavObjectType } from '../Components/navigationTypes'
/*
 * This context is for passing down the function to navigate the main component of our shell
 */

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const NavigationContext = createContext((navObject: NavObjectType) => { return; })